import lodash from 'lodash';
import {
  handleGetOutfits,
  handleGetCurrentUserOutfits
} from '@/store/api/outfit';

import OutfitService from '@/services/api/OutfitService';

function findOutfitById(outfitId) {
  return state.capsuleOutfits.find(o => o['id'] === outfitId)
};

function findOutfitFromLayerProducts(layerProducts) {
  const ids = Object.values(layerProducts).filter(Boolean).sort()

  return state.capsuleOutfits.find((o) => {
    const productIds = o.products.map(p => p['id']).sort()
    return JSON.stringify(ids) === JSON.stringify(productIds)
  });
};

// function buildOutfitLayerProducts(outfit) {
//   const obj = Object.assign({}, ...Object.keys(state.selectedOutfit.layerProducts).map(
//     (key) => ({[key]: null}))
//   )

//   outfit.products.forEach(p => {obj[p.layer_slug] = p.id});

//   return obj
// };

function buildOutfitLayerProducts(outfit) {
  const response = {
    outerwear: null,
    midwear: null,
    innerwear: null,
    bottoms: null,
    footwear: null,
    accessories1: null,
    accessories2: null
  }

  outfit.products.forEach(p => response[p.layer_slug] = p.id)
  return response
};

const state = {
  allOutfits: [],
  allOutfitsWithLayers: [],
  capsuleOutfits: [],
  currentUserAllOutfits: [],
  error: '',
  selectedOutfit: {
    outfitId: null,
    title: null,
    userTitle: null,
    stitchesCount: null,
    layerProducts: {
      outerwear: null,
      midwear: null,
      innerwear: null,
      bottoms: null,
      footwear: null,
      accessories1: null,
      accessories2: null
    }
  },
  discoverOutfits: {
    all: [],
    latest: [],
    metaData: {},
  }
};

const getters = {
  allOutfits: state => state.allOutfits,
  allOutfitsWithLayers: state => state.allOutfitsWithLayers,
  capsuleOutfits: state => state.capsuleOutfits,
  currentUserAllOutfits: state => state.currentUserAllOutfits,
  discoverOutfits: state => state.discoverOutfits,
  selectedOutfit: state => state.selectedOutfit,
};

const actions = {
  resetDiscoverOutfits({ commit, dispatch }) {
    commit('SAVE_DISCOVER_OUTFITS_ALL', [])
    commit('SAVE_DISCOVER_OUTFITS_LATEST', [])
    // Need to resetAllStitches
    // i.e dispatch('resetAllVotes')
  },

  resetSelectedOutfit({ commit, dispatch }) {
    const payload = {
      outfitId: null,
      title: null,
      userTitle: null,
      stitchesCount: null,
      layerProducts: {
        outerwear: null,
        midwear: null,
        innerwear: null,
        bottoms: null,
        footwear: null,
        accessories1: null,
        accessories2: null
      }
    }
    commit('SAVE_SELECTED_OUTFIT', payload);
  },

  checkAndSetOutfit({ commit }, { outfitId, layerProducts }) {
    if (!(outfitId || layerProducts)) return

    const outfit = outfitId
      ? findOutfitById(outfitId)
      : findOutfitFromLayerProducts(layerProducts)

    if(outfitId && outfit) layerProducts = buildOutfitLayerProducts(outfit)

    const payload = {
      outfitId: outfit ? outfit.id : null,
      title: outfit ? outfit.title : null,
      userTitle: outfit ? outfit.user_title : null,
      stitchesCount: outfit ? outfit.stitches_count : null,
      layerProducts: layerProducts
    }

    commit('SAVE_SELECTED_OUTFIT', payload);
  },

  fetchAllOutfits({ commit }, payload) {
    const params = {
      filter: payload.filter,
      page: payload.page,
      per_page: payload.per_page
    }

    return OutfitService.getAll(params)
      .then((response) => {
        const outfits = response.data.outfits

        params.page && params.page > 1
          ? commit('APPEND_DISCOVER_OUTFITS_ALL', outfits)
          : commit('SAVE_DISCOVER_OUTFITS_ALL', outfits);

        commit('SAVE_DISCOVER_OUTFITS_LATEST', outfits);
        commit('SAVE_DISCOVER_OUTFITS_META_DATA', response.data.meta);
      })
      .catch(error => {
        // commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  async fetchCapsuleOutfits({ commit, dispatch }, capsuleId) {
    const { data, message } = await handleGetOutfits(capsuleId, false);

    if (data) {
      commit('SAVE_CAPSULE_OUTFITS', data);
      // dispatch('checkAndSetOutfit')

    } else {
      commit('SAVE_ERROR_RESPONSE', message);
    }
  },

  async fetchOutfits({ commit, dispatch }, capsuleId) {
    const { data, message } = await handleGetOutfits(capsuleId, false);

    if (data) {
      commit('SAVE_GET_OUTFITS_RESPONSE', data);
      // dispatch('checkAndSetOutfit')

    } else {
      commit('SAVE_ERROR_RESPONSE', message);
    }
  },

  async fetchOutfitsWithLayers({ commit }, capsuleId) {
    const { data, message } = await handleGetOutfits(capsuleId, true);

    if (data) {
      commit('SAVE_GET_OUTFITS_WITH_LAYERS_RESPONSE', data);
    } else {
      commit('SAVE_ERROR_RESPONSE', message);
    }
  },

  createOutfit({ commit, dispatch}, { outfitId, capsuleId, title, productIds }) {
    if(outfitId && (!productIds || productIds.length === 0)) {
      productIds = findOutfitById(outfitId).products.map(p => p.id)
    }

    return OutfitService.create(outfitId, capsuleId, title, productIds)
      .then((response) => {
        const outfit = response.data
        const outfitPayload = { outfitId: outfitId, outfitData: outfit }

        if (outfitId) {
          commit('REPLACE_OUTFIT_IN_CAPSULE_OUTFITS', outfitPayload);
        } else {
          commit('ADD_TO_CAPSULE_OUTFITS', outfit);
        }

        const selectedOutfitPayload = {
          outfitId: outfit.id,
          title: outfit.title,
          userTitle: outfit.user_title,
          stitchesCount: outfit.stitches_count,
          layerProducts: buildOutfitLayerProducts(outfit)
        }
        commit('SAVE_SELECTED_OUTFIT', selectedOutfitPayload)

        const counterPayload = {
          capsuleId: (outfitId ? outfitData : outfit)['capsule_id'],
          counterName: 'outfits_count',
          direction: 'up'
        }
        dispatch('adjustCapsuleCounter', counterPayload)
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  destroyOutfit({ commit, dispatch, state }, { outfitId }) {
    const capsuleId = findOutfitById(outfitId)['capsule_id']

    return OutfitService.destroy(outfitId)
      .then((response) => {
        const outfitData = response.data
        const payload = { outfitId: outfitId, outfitData: outfitData }

        commit('REPLACE_OUTFIT_IN_CAPSULE_OUTFITS', payload);

        if (state.selectedOutfit.outfitId === outfitId) {
          const selectedOutfit = {
            ...state.selectedOutfit,
            outfitId: outfitData ? outfitData.id : null,
            title: outfitData ? outfitData.title : null,
            userTitle: null,
            stitchesCount: outfitData ? outfitData.stitches_count : null
          }
          commit('SAVE_SELECTED_OUTFIT', selectedOutfit)
        }

        if (!outfitData) {
          const counterPayload = {
            capsuleId: capsuleId,
            counterName: 'outfits_count',
            direction: 'down'
          }
          dispatch('adjustCapsuleCounter', counterPayload)
        }
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  updateOutfit({ commit }, { outfitId, title }) {
    return OutfitService.update(outfitId, title)
      .then((response) => {
        const outfit = response.data
        const outfitPayload = { outfitId: outfitId, outfitData: outfit }
        const selectedOutfitPayload = {
          outfitId: outfit.id,
          title: outfit.title,
          userTitle: outfit.user_title,
          stitchesCount: outfit.stitches_count,
          layerProducts: buildOutfitLayerProducts(outfit)
        }

        commit('REPLACE_OUTFIT_IN_CAPSULE_OUTFITS', outfitPayload);
        commit('SAVE_SELECTED_OUTFIT', selectedOutfitPayload)
    })
    .catch(error => {
      commit('SAVE_ERROR_RESPONSE', error.message);
    })
  },

  // #########################################################################
  //
  // USER STITCHED OUTFITS PAGE
  //
  // #########################################################################

  async fetchCurrentUserOutfits({ commit }, userId) {
    const { data, message } = await handleGetCurrentUserOutfits(userId);

    data
      ? commit('SAVE_GET_CURRENT_USER_OUTFITS_RESPONSE', data)
      : commit('SAVE_ERROR_RESPONSE', message)
  },

  destroyUserOutfit({ commit }, outfitId) {
    return OutfitService.destroy(outfitId)
      .then(() => {
        commit('REMOVE_OUTFIT_FROM_CURRENT_USER_ALL_OUTFITS', outfitId)
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  // #########################################################################
  //
  // DISCOVER OUTFITS PAGE
  //
  // #########################################################################

  stitchDiscoverOutfit({ commit, dispatch }, outfit) {
    const productIds = outfit.products.map(p => p.id)

    return OutfitService.create(outfit.id, outfit.capsule_id, outfit.title, productIds)
      .then((response) => {
        const outfitPayload = { type: 'all', outfitId: outfit.id, outfit: response.data }

        commit('REPLACE_DISCOVER_OUTFIT', outfitPayload);
        dispatch('updateAllStitches', { type: "add", outfitId: outfit.id })
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },

  unstitchDiscoverOutfit({ commit, dispatch }, outfit) {
    const outfitId = outfit.id
    const capsuleId = outfit.capsule_id

    return OutfitService.destroy(outfitId)
      .then((response) => {
        const outfitData = response.data
        const payload = { type: 'all', outfitId: outfitId, outfit: outfitData }

        commit('REPLACE_DISCOVER_OUTFIT', payload);
        dispatch('updateAllStitches', { type: "remove", outfitId: outfitId })

        if (!outfitData) {
          const counterPayload = {
            capsuleId: capsuleId,
            counterName: 'outfits_count',
            direction: 'down'
          }
          dispatch('adjustCapsuleCounter', counterPayload)
        }
      })
      .catch(error => {
        // commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },
};

const mutations = {

  // #########################################################################
  //
  // CAPSULE OUTFITS
  //
  // #########################################################################

  ADD_TO_CAPSULE_OUTFITS(state, outfitData) {
    state.capsuleOutfits.push(outfitData);
  },

  REPLACE_OUTFIT_IN_CAPSULE_OUTFITS(state, { outfitId, outfitData }) {
    const index = state.capsuleOutfits.findIndex(o => o.id === outfitId);

    if (index > -1) {
      outfitData
        ? state.capsuleOutfits.splice(index, 1, outfitData)
        : state.capsuleOutfits.splice(index, 1)
    }
  },

  SAVE_CAPSULE_OUTFITS(state, response) {
    state.capsuleOutfits = response;
  },

  // #########################################################################
  //
  // --------------------
  //
  // #########################################################################

  SAVE_SELECTED_OUTFIT(state, selectedOutfitData) {
    state.selectedOutfit = selectedOutfitData;
  },

  // UPDATE_NEW_SELECTED_OUTFIT_LAYER_PRODUCT(state, { layerSlug, productId }) {
  //   state.selectedOutfit.layerProducts[layerSlug] = productId;
  // },

  // UPDATE_NEW_SELECTED_OUTFIT_DATA(state, payload) {
  //   state.selectedOutfit.outfitId = payload['outfitId']
  //   state.selectedOutfit.title = payload['title']
  //   state.selectedOutfit.userTitle = payload['userTitle']
  //   state.selectedOutfit.stitchesCount = payload['stitchesCount']
  // },

  SAVE_GET_OUTFITS_RESPONSE(state, response) {
    state.allOutfits = response;
  },

  SAVE_GET_OUTFITS_WITH_LAYERS_RESPONSE(state, response) {
    state.allOutfitsWithLayers = response;
  },

  SAVE_GET_CURRENT_USER_OUTFITS_RESPONSE(state, response) {
    state.currentUserAllOutfits = response;
  },

  APPEND_DISCOVER_OUTFITS_ALL(state, response) {
    state.discoverOutfits.all = state.discoverOutfits.all.concat(response);
  },

  SAVE_DISCOVER_OUTFITS_LATEST(state, response) {
    state.discoverOutfits.latest = response;
  },

  SAVE_DISCOVER_OUTFITS_ALL(state, response) {
    state.discoverOutfits.all = response;
  },

  SAVE_DISCOVER_OUTFITS_META_DATA(state, response) {
    state.discoverOutfits.metaData = response;
  },

  REMOVE_OUTFIT_FROM_CURRENT_USER_ALL_OUTFITS(state, outfitId) {
    const index = state.currentUserAllOutfits.findIndex(o => o.id === outfitId);

    if (index > -1) {
      state.currentUserAllOutfits.splice(index, 1)
    }
  },

  // #########################################################################
  //
  // DISCOVER OUTFITS
  //
  // #########################################################################

  REPLACE_DISCOVER_OUTFIT(state, { type, outfitId, outfit }) {
    const index = state.discoverOutfits[type].findIndex(o => o.id === outfitId);

    if (index > -1) {
      outfit
        ? state.discoverOutfits[type].splice(index, 1, outfit)
        : state.discoverOutfits[type].splice(index, 1)
    }
  },

  UPDATE_DISCOVER_OUTFIT(state, { type, outfitId, outfit }) {
    const index = state.discoverOutfits[type].findIndex(o => o.id === outfitId);

    if (index !== -1) {
      state.discoverOutfits[type].splice(index, 1, outfit)
    }
  },

  REMOVE_DISCOVER_OUTFIT(state, { type, outfitId }) {
    const index = state.discoverOutfits[type].findIndex(o => o.id === outfitId);

    if (index !== -1) {
      state.discoverOutfits[type].splice(index, 1)
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/outfit/index.js